import { authorize, getRequest } from 'utils/http';
import { Environment } from 'global/environment';

export async function getAgreementsAPI(registrationNumber) {
  return getRequest(`${Environment.BACKEND_API}/agreements/${registrationNumber}`, await authorize());
}
